import RisikoanalyseStepForm from "./RisikoanalyseStepForm";
import { stepFormSchemaKurz } from "../components/risikoanalyseStep/schemaKurz";

/**
 * Public-facing short version of the Risikoanalyse, rendered as a
 * step-based form that reuses the same engine, welcome page, sidebar,
 * progress bar and contact-data prefill as the long form.
 *
 * Storage prefixes are namespaced separately so that drafts and the
 * "welcome already seen" flag don't collide with the long form.
 */
const PublicCustomerRisikoanalyseKurzForm = () => (
  <RisikoanalyseStepForm
    schema={stepFormSchemaKurz}
    welcomeStoragePrefix="risikoanalyse-kurz-welcome-seen:"
    draftStoragePrefix="risikoanalyse-kurz-draft:"
    submitVersion="kurz-step-form-v1"
  />
);

export default PublicCustomerRisikoanalyseKurzForm;
